<div class="footer position-relative">
    <footer-navigation class="d-block mb-4 mb-md-5" [isMaintenance]="isMaintenance"></footer-navigation>
    <footer-products class="d-block" *ngIf="!isMaintenance"></footer-products>
    <!-- <footer-info></footer-info> -->
</div>